export * from "./instagram.component";
